export function isNetworkFailure(error: unknown): boolean {
  if (!error) return false;
  const e = error as { message?: string; name?: string };
  return (
    e.message?.includes("Failed to fetch") === true ||
    e.message?.includes("NetworkError") === true ||
    e.message?.includes("Network request failed") === true ||
    e.message?.includes("Session check timeout") === true ||
    e.name === "NetworkError" ||
    e.name === "TypeError"
  );
}

export function isRefreshTokenError(error: unknown): boolean {
  if (!error) return false;
  const e = error as { code?: string; message?: string; status?: number };
  return (
    e.code === "refresh_token_not_found" ||
    e.message?.includes("Refresh Token Not Found") === true ||
    e.message?.includes("Invalid Refresh Token") === true ||
    (e.status === 400 && e.code === "refresh_token_not_found")
  );
}
